module.exports = __webpack_public_path__ + "static/media/student5.04c2bc64.png";